import { render, staticRenderFns } from "./productSeries.vue?vue&type=template&id=64336802&scoped=true"
import script from "./productSeries.vue?vue&type=script&lang=js"
export * from "./productSeries.vue?vue&type=script&lang=js"
import style0 from "./productSeries.vue?vue&type=style&index=0&id=64336802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64336802",
  null
  
)

export default component.exports